import { lazy } from 'react';

import { withCampaignSavedData } from './withCampaignSavedData';

const LazyFormPagesStep01 = lazy(() =>
  import('./FormPagesStep01').then((module) => ({ default: module.FormPagesStep01 })),
);

export const EnhancedFormPagesStep01 = withCampaignSavedData(LazyFormPagesStep01);
